export default "__VITE_ASSET__DUN1PXJ2__"